// 存储选择文案转成的markdown字符串
export const SET_SELECTION_MARKDOWN_TEXT = 'SET_SELECTION_MARKDOWN_TEXT'
// 对话结束
export const SET_CURRENT_SESSION_IS_OVER = 'SET_CURRENT_SESSION_IS_OVER'
